/*
 * File: server.ts
 * File Created: 2023-11-27 03:22:24
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-13 05:31:04
 * Modified By: Val Liu
 * -----
 */

import {
    ValServerBase,
    ApisRequestBase,
    InputR,
    OutputR,
    OutputU,
    InputU,
} from "@/../core/server";

interface RestfulRequest extends ApisRequestBase {
    Get: {
        "/file": [any, any, false];
    };

    Patch: {
        "/license": [any, any, false];
        "/license/mac": [any, any, false];
        "/auth/apis": [any, any, false];
        "organization": [InputR<any>, OutputR<any>, false];
        "translation-job": [InputR<any>, OutputR<any>, false];
    };

    Post: {
        "/license": [any, any, false];
        "translation-job-draft/analyze": [any, any, false];
        "translation-job-draft/confirm": [any, any, false];
        "promotion-code/redeem": [any, any, false];
        "ecpay/credit/create-order": [any, any, false];
    };

    Put: {
        "/user": [any, any, false];
        "translation-job": [InputU<any>, OutputU<any>, false];
    };

    Delete: {
        "/license": [any, any, false];
        "/user": [any, any, false];
    };
    Ws: {};
}

export class Server extends ValServerBase<RestfulRequest> {}
export default Server;
